import React, { useState } from "react";
import "./Navbar.css";
import { BiMenuAltRight } from "react-icons/bi";
import { RxCross2 } from "react-icons/rx";
import logoImg from "../../images/leadlytics.png";

const Navbar = () => {
  const [mobileMenuOpened, setMobileMenuOpened] = useState(false);
  // const [navStyle, setNavStyle] = useState("");

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY > window.innerHeight * 0.2) {
  //       setNavStyle("sticky");
  //     } else {
  //       setNavStyle("");
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  return (
    <div className="n-wrapper pr-5 pl-5 sticky">
      {/* desktop version */}
      <div className="container">
        <div className="n-container">
          {/* left side */}
          <div className="n-logo">
            <a href="/" className="inline-block max-w-[160px]">
              <img src={logoImg} alt="logo" className="max-w-[90px]" />
            </a>
          </div>

          {/* right side */}
          <div className="n-right">
            <div className="n-menu">
              <a href="/" spy={true} smooth={true}>
                <span>Home</span>
              </a>
              <a href="/services" spy={true} smooth={true} offset={100}>
                <span>Services</span>
              </a>
              <a href="/portfolio" spy={true} smooth={true}>
                <span>Portfolio</span>
              </a>
              <a href="/contact" spy={true} smooth={true} offset={100}>
                <span>Contact</span>
              </a>
            </div>
            <div className="fund-button bg-[#BAB5B5]">
              <a href="/signin">SignIn</a>
            </div>
          </div>
        </div>
      </div>

      {/* mobile version */}
      <div className="nm-container">
        {/* logo */}
        <a href="/" className="inline-block max-w-[160px]">
          <img src={logoImg} alt="logo" className="max-w-[65px]" />
        </a>

        {/* menu icon */}
        {!mobileMenuOpened ? (
          <BiMenuAltRight size={30} onClick={() => setMobileMenuOpened(true)} />
        ) : (
          <RxCross2 size={30} onClick={() => setMobileMenuOpened(false)} />
        )}

        <div
          className="nm-menu"
          style={{
            transform: mobileMenuOpened
              ? "translateX(0%)"
              : "translateX(-100%)",
          }}
        >
          <span onClick={() => setMobileMenuOpened(false)}>
            <a href="/" spy={true} smooth={true}>
              <span>Home</span>
            </a>
          </span>
          <span onClick={() => setMobileMenuOpened(false)}>
            <a href="/services" spy={true} smooth={true}>
              <span>Services</span>
            </a>
          </span>
          <span onClick={() => setMobileMenuOpened(false)}>
            <a href="/portfolio" spy={true} smooth={true}>
              <span>Portfolio</span>
            </a>
          </span>
          <span onClick={() => setMobileMenuOpened(false)}>
            <a href="/contact" spy={true} smooth={true}>
              <span>Contact</span>
            </a>
          </span>
          <div
            className="m-funded-button bg-[#BAB5B5] text-black"
            onClick={() => setMobileMenuOpened(false)}
          >
            <a href="/signin" spy={true} smooth={true}>
              <span>SignIn</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
